import { render, staticRenderFns } from "./growing_up.vue?vue&type=template&id=257dfffb&scoped=true"
import script from "./growing_up.vue?vue&type=script&lang=js"
export * from "./growing_up.vue?vue&type=script&lang=js"
import style0 from "./growing_up.vue?vue&type=style&index=0&id=257dfffb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257dfffb",
  null
  
)

export default component.exports